<template>
  <div
    class="tw-rounded-sm tw-bg-white tw-h-full"
    :data-test-id="`${tier}-sat-chart`"
  >
    <div class="tw-flex tw-justify-between tw-items-center tw-p-4">
      <div class="tw-flex tw-items-center tw-gap-2">
        <div
          v-tippy="{
            content: $t('sat-label'),
            placement: 'top',
          }"
        >
          <div
            class="tw-w-8 tw-h-8 tw-p-0.5 tw-bg-white tw-rounded-full tw-flex tw-items-center tw-justify-center tw-place-self-center"
            :data-test-id="`${tier}-sat-chart-icon`"
          >
            <component :is="icon" width="24" height="24" />
          </div>
        </div>
        <div class="tw-text-lg tw-font-semibold">
          {{ $t("sat-label") }}
        </div>
      </div>
      <div
        v-tippy="{
          content: $t('training-in-progress'),
          placement: 'top',
        }"
        class="tw-text-primary-grey-200"
        :data-test-id="`${tier}-sat-chart-info-icon`"
      >
        <cb-icon-information :width="18" />
      </div>
    </div>
    <div class="tw-p-4">
      <div
        id="sat-appcues-placeholder"
        class="tw-flex tw-items-center tw-justify-center tw-py-10 tw-text-gray-400"
      >
        <cl-icon-empty-graph :width="128" color="currentColor" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SERVICE_ICON } from "@/utils/services";
import { useIsMspRoute } from "@/composables/useIsMspRoute";

const { isMspRoute } = useIsMspRoute();

const tier = isMspRoute.value ? "msp" : "customer";

const icon = SERVICE_ICON.SAT_SERVICE;
</script>
